import React, { Component } from 'react';
/*import logo from './logo.svg';
import './App.css';
import ListItem from './components/ListItem';
import { Button } from 'react-bootstrap';
import FormExample from './components/FormExample';

class App extends Component {
	constructor(){
		super();
		this.state={
			contacts: []
		};
	}
	componentDidMount(){
		fetch('./data.json')
			.then((response) => response.json())
			.then((responseData) => {
				this.setState({contacts: responseData});
			})
			.catch((error) => {
				console.log('Error fetching and parsing data', error);
			});
	}
	
	render() {
		return (
		  <div className="App">
			<div className="App-header">
			  <img src={logo} className="App-logo" alt="logo" />
			  <h2>Welcome to React</h2>
			</div>
			<p className="App-intro">
			  To get started, edit <code>src/App.js</code> and save to reload.
			</p>
			<ul>
				{this.state.contacts.map(
					(contact) => <ListItem key={contact.id}
						name={contact.name}
						quantity={contact.id} />
				)}
				<ListItem quantity="1" name="Bread" />
				<ListItem quantity="6" name="Eggs" />
				<ListItem quantity="2" name="Milk" />
			</ul>
			<Button>Ciao</Button>
			<FormExample />
		  </div>
		);
	 }
}*/

import { Grid, Row, Col, Button } from 'react-bootstrap';
import TextBox from './components/TextBox';
import DateBox from './components/DateBox';
import SelectBox from './components/SelectBox';
import SymbolsBox from './components/SymbolsBox';
import TableResults from './components/TableResults';

class App extends Component {
	constructor(){
		super();
		this.state={
			filterText: '',
			dateFrom: '',
			dateTo: '',
			select: 1,
			symbol: '^GSPC',
			twitterToVisualize: [],
			pagination: 0,
			lastDataSent: null,
			totalResults: 0
		};
	}
	
	search(){
		console.log('do search');
	}
	
	updateText(newText){
		this.setState({filterText: newText});
	}
	
	updateDateFrom(newDate){
		this.setState({dateFrom: newDate});
	}
	
	updateDateTo(newDate){
		this.setState({dateTo: newDate});
	}
	
	updateSelect(newSelect){
		this.setState({select: newSelect});
	}
	
	updateSymbol(newSymbol){
		this.setState({symbol: newSymbol});
	}
	
	getValidationFrom() {
		if(!isNaN(Date.parse(this.state.dateFrom)) || this.state.dateFrom === ''){
			return 'success';
		}else{
			return 'error';
		}
	}
	
	getValidationTo() {
		if(!isNaN(Date.parse(this.state.dateTo)) || this.state.dateTo === ''){
			return 'success';
		}else{
			return 'error';
		}
	}
	
	updateData(){
		var fd = new FormData();
		fd.append('text', this.state.filterText);
		if(!isNaN(Date.parse(this.state.dateFrom))){
			fd.append('from', Date.parse(this.state.dateFrom)/1000);
		}
		if(!isNaN(Date.parse(this.state.dateTo))){
			fd.append('to', Date.parse(this.state.dateTo)/1000);
		}
		fd.append('followed', this.state.select);
		fd.append('symbol', this.state.symbol);
		fd.append('pagination', 0);
		var myParam = {
			method: 'POST',
			body: fd
		};
		//fetch('/twitter/visualizer.php', myParam)
		fetch('http://redchang.homelinux.net/twitter/visualizer.php', myParam)
			.then((response) => response.json())
			.then((responseData) => {
				this.setState({twitterToVisualize: responseData['rows'], totalResults: responseData['count_rows'], pagination: 0, lastDataSent: fd});
			})
			.catch((error) => {
				console.log('Error fetching and parsing data', error);
			});
	}
	
	anotherPage(){
		var fd = this.state.lastDataSent;
		fd.append('text', this.state.filterText);
		if(!isNaN(Date.parse(this.state.dateFrom))){
			fd.append('from', Date.parse(this.state.dateFrom)/1000);
		}
		if(!isNaN(Date.parse(this.state.dateTo))){
			fd.append('to', Date.parse(this.state.dateTo)/1000);
		}
		fd.append('followed', this.state.select);
		fd.append('symbol', this.state.symbol);
		fd.set('pagination', parseInt(fd.get('pagination'), 10)+1);
		var myParam = {
			method: 'POST',
			body: fd
		};
		//fetch('/twitter/visualizer.php', myParam)
		fetch('http://redchang.homelinux.net/twitter/visualizer.php', myParam)
			.then((response) => response.json())
			.then((responseData) => {
				this.setState({twitterToVisualize: this.state.twitterToVisualize.concat(responseData['rows']), pagination: 0, lastDataSent: fd});
			})
			.catch((error) => {
				console.log('Error fetching and parsing data', error);
			});
	}
	
	render() {
		return (
			<Grid>
				<Row>
					<Col xs={12} sm={6} md={3}>
						<TextBox filterText={this.state.filterText} update={this.updateText.bind(this)} />
					</Col>
					<Col xs={12} sm={6} md={3}>
						<DateBox filterText={this.state.dateFrom} validator={this.getValidationFrom.bind(this)} update={this.updateDateFrom.bind(this)} />
					</Col>
					<Col xs={12} sm={6} md={3}>
						<DateBox filterText={this.state.dateTo} validator={this.getValidationTo.bind(this)} update={this.updateDateTo.bind(this)} />
					</Col>
					<Col xs={12} sm={6} md={3}>
						<SelectBox update={this.updateSelect.bind(this)} selected={this.state.select} />
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<SymbolsBox update={this.updateSymbol.bind(this)} selected={this.state.symbol} />
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<Button block onClick={this.updateData.bind(this)}>Cerca</Button>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12} style={{marginTop:'15px'}}>
						<TableResults results={this.state.twitterToVisualize} totalResults={this.state.totalResults} anotherPage={this.anotherPage.bind(this)} />
					</Col>
				</Row>
			</Grid>
		);
	 }
}

/*import TestMio from './TestMio';

class App extends Component {
	
	render() {
		return (
			<div>
				<TestMio />
			</div>
		);
	 }
}*/

export default App;



// WEBPACK FOOTER //
// ./src/App.js